import { captureException } from '@sentry/capacitor';

export const useCostCodeStore = defineStore('CostCodeStore', () => {
  const appApiFetch = getAppApiFetch();
  const { openToast } = useUserMessages();
  const { t } = useEkI18n(); 

  const projectCostCode = ref<ProjectCostCodeRootResponseDTO[] | null>(null);
  const validationLevel = ref<MissingCostCodeValidationLevel | null>(null);

  async function getProjectCostCodes(projectId: number) {
    const url = versionedUrl('Project/GetProjectCostCodesByProjectID') + '?projectId=' + projectId;

    try {
      const response = await appApiFetch<ResponseDTO<AppProjectCostCode>>(url, { method: 'GET' });

      if (response && !response.HasErrors) {
        projectCostCode.value = response.Data.ProjectCostCodeRootResponseDTO;
        validationLevel.value = response.Data.ValidationLevel;
      }
    } catch (error) {
      captureException(error);
      openToast(t('error.generic'), ToastType.ERROR);
    }
  }

  async function getProjectCostCodeFromItem(item: MaterialItemApp, projectId: number, worksheetId: number) {
    try {
      const requestBody: ItemCostCodeRequest = {
        ProjectId: projectId,
        WorksheetId: worksheetId,
        CatalogId: item.CatalogId ?? 0,
        SumCostCodeName: item.SumCostCodeName ?? null,
        SumCostCodeAlias: item.SumCostCodeAlias ?? null,
        CostCodeName: item.CostCodeName ?? null,
        CostCodeAlias: item.CostCodeAlias ?? null,
        WholesalerID: item.WholesalerID
      };
  
      const response = await appApiFetch<ResponseDTO<ItemProjectCostCodeIDResponse>>(
        versionedUrl('Catalog/GetProjectCostCodeForItem'),
        { method: 'POST', body: requestBody }
      );
  
      if (response && response.Data) {
        let matchingCostCode = null;
  
        if (projectCostCode.value) {
          matchingCostCode = projectCostCode.value.find((costCode) => costCode.ID === response.Data.ItemProjectCostCode);
  
          if (!matchingCostCode) {
            for (const rootCostCode of projectCostCode.value) {
              matchingCostCode = rootCostCode.CostCodes.find(
                (childCostCode) => childCostCode.ID === response.Data.ItemProjectCostCode
              );

              if (matchingCostCode) break;
            }
          }
        }
  
        return matchingCostCode;
      }
    } catch (error) {
      captureException(error);
      openToast(t('error.generic'), ToastType.ERROR);
    }
  }

  return {
    getProjectCostCodes,
    getProjectCostCodeFromItem,
    _projectCostCode: projectCostCode,
    _validationLevel: validationLevel,
    projectCostCode: readonly(projectCostCode),
    validationLevel: readonly(validationLevel)
  };
});